import Report from "./index.vue";
import Vue from "vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  computed: {
    planId() {
      return Number(this.$route.params["planId"]);
    },
    reports() {
      return this.$store.state.domains.reports.reports;
    },
    report() {
      return this.$store.state.domains.report.report;
    }
  },
  mounted() {
    this.getReports({ planId: this.planId });
    this.getReport({ planId: this.planId, reportId: 1, type: "WEEKLY" });
  },
  methods: {
    async getReports(params) {
      try {
        await this.$store.dispatch("domains/reports/getReports", params);
      } catch (error) {
        throw error;
      }
    },
    async getReport(params) {
      try {
        await this.$store.dispatch("domains/report/getReport", params);
      } catch (error) {
        throw error;
      }
    }
  },
  render(createElement) {
    return createElement(Report, {
      props: {
        reports: this.reports,
        report: this.report
      }
    });
  }
});
